import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from "react-query";
import { fetchOutboundConfig } from "@/services/outbound";
var STALE_MS = 5 * 60 * 1000;

/** Metadata identifying a resource config (type + action). */

/**
 * Query hook for the workspace outbound config. Exposes whether outbound is
 * enabled and the resolved Encounter create config + metadata. The request is
 * deferred until {@link enabled} is true so it only fires on user intent.
 */
export function useOutboundConfig(workspaceId) {
  var _query$data, _query$data2, _encounterWrapper$con, _docWrapper$config, _query$data$configs$l, _query$data3;
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var query = useQuery(["outbound-config", workspaceId], function () {
    return fetchOutboundConfig(workspaceId);
  }, {
    enabled: enabled && Boolean(workspaceId),
    staleTime: STALE_MS,
    retry: false
  });
  var encounterWrapper = (_query$data = query.data) === null || _query$data === void 0 ? void 0 : _query$data.configs.find(function (wrapper) {
    return wrapper.resource_type === "Encounter" && wrapper.enabled;
  });
  var docWrapper = (_query$data2 = query.data) === null || _query$data2 === void 0 ? void 0 : _query$data2.configs.find(function (wrapper) {
    return wrapper.resource_type === "DocumentReference" && wrapper.enabled;
  });
  var encounterConfig = (_encounterWrapper$con = encounterWrapper === null || encounterWrapper === void 0 ? void 0 : encounterWrapper.config) !== null && _encounterWrapper$con !== void 0 ? _encounterWrapper$con : null;
  var encounterMeta = encounterWrapper ? {
    resourceType: encounterWrapper.resource_type,
    action: encounterWrapper.action
  } : null;
  var docCreationConfig = (_docWrapper$config = docWrapper === null || docWrapper === void 0 ? void 0 : docWrapper.config) !== null && _docWrapper$config !== void 0 ? _docWrapper$config : null;
  var docCreationMeta = docWrapper ? {
    resourceType: docWrapper.resource_type,
    action: docWrapper.action
  } : null;
  return _objectSpread(_objectSpread({}, query), {}, {
    isEnabled: ((_query$data$configs$l = (_query$data3 = query.data) === null || _query$data3 === void 0 ? void 0 : _query$data3.configs.length) !== null && _query$data$configs$l !== void 0 ? _query$data$configs$l : 0) > 0,
    encounterConfig: encounterConfig,
    encounterMeta: encounterMeta,
    docCreationConfig: docCreationConfig,
    docCreationMeta: docCreationMeta
  });
}